$(document).ready(function() {
  var btn = '#video_play';
  var vid_btn = '#video_article';
  $(btn).click(function() {
    $(vid_btn).addClass("play");
  });
  $(vid_btn).click(function() {
    if ($(btn).attr('data-click') == 1) {
      $(btn).attr('data-click', 0)
      $(vid_btn)[0].pause();
      //               $('.btntext-wrap').show();
    } else {
      $(btn).attr('data-click', 1)
      $(vid_btn)[0].play();
      $('.btntext-wrap').hide();
    }
  });
  $(btn).on('click', function() {
    this.controls = false;
    if ($(this).attr('data-click') == 1) {
      $(this).attr('data-click', 0)
      $(vid_btn)[0].pause();
      //               $('.btntext-wrap').show();
    } else {
      $(this).attr('data-click', 1)
      $(vid_btn)[0].play();
      $('.btntext-wrap').hide();
    }
  });
});

$('.blog-article .inter_slider').slick({
  slidesToShow: 3,
  slidesToScroll: 3,
  arrows: true,
  fade: false,
  dots: false,
  infinite: false,
  speed: 100,
  touchThreshold: 100,
  swipeToSlide: true,
  waitForAnimate: false,
  responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      }
    },
    {
      breakpoint: 520,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]
});
